import { render, staticRenderFns } from "./ModalTabelaRegrasGerenciamentoEquipes.vue?vue&type=template&id=1e41c5fe"
import script from "./ModalTabelaRegrasGerenciamentoEquipes.vue?vue&type=script&lang=ts"
export * from "./ModalTabelaRegrasGerenciamentoEquipes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports